import Loading from "../../../Layouts/Loading";
import { useGetQuestionQuery } from "../../../Redux/Apis/examApi";
import { safeParseHtml } from "../../../utils/safeParseHtml";

function Question({ examId, qstId, userExam, resetKey, answerMode, detail, setDetail }: any) {
    const {
        data,
        isLoading,
        isSuccess,
    } = useGetQuestionQuery({ examId, qstId, userExam, resetKey, answerMode });

    if (isLoading) return <Loading />;

    if (!isSuccess || !data) return <>Not Found</>;

    const userAnswer = data.UserAnswer && data.UserAnswer.answer ? data.UserAnswer.answer : "";
    const correctAnswer = data.answersheet || "";
    const shownAnswer = answerMode === "user" ? userAnswer : correctAnswer;
    const answerLabel = answerMode === "user" ? "Your Answer" : "Correct Answer";

    return (
        <>
            <div className="mt-3 text-end">
                <p className="mb-1">
                    <b>{answerLabel}:</b>{" "}
                    <span className="user-select-all">
                        {shownAnswer ? safeParseHtml(shownAnswer) : "—"}
                    </span>
                </p>
            </div>

            {/* Answer explanation modal */}
            <div
                className={`modal fade ${detail ? "show d-block" : ""}`}
                tabIndex={-1}
                style={{ background: detail ? "rgba(0, 0, 0, 0.5)" : "transparent" }}
            >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" style={{ color: "#800080" }}>
                                Answer Explanation
                            </h5>
                        </div>

                        <div className="modal-body text-end">
                            <div>
                                {data.answersheet_explain
                                    ? safeParseHtml(data.answersheet_explain)
                                    : "Answer Explanation not found for this Question!"}
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => setDetail(false)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Question;

